module.exports = __webpack_public_path__ + "img/9.40b6ef81.png";